import type {
  CareerExplorerRecommendation,
  CareerExplorerRecommendationsProps,
} from './types';

const MAX_RECOMMENDATIONS = 8;

export function visibleCareerExplorerPrograms(
  programs: CareerExplorerRecommendation[],
  maxRecommendations: number = MAX_RECOMMENDATIONS,
): CareerExplorerRecommendation[] {
  const recommendationLimit = Math.max(0, maxRecommendations);

  return programs
    .filter((program) => program.title.trim().length > 0)
    .slice(0, recommendationLimit);
}

/** True when the recommendations panel will render instead of returning null. */
export function shouldShowCareerExplorerRecommendations({
  hideWhenEmpty = true,
  maxRecommendations = MAX_RECOMMENDATIONS,
  programs,
}: Pick<
  CareerExplorerRecommendationsProps,
  'hideWhenEmpty' | 'maxRecommendations' | 'programs'
>): boolean {
  if (!hideWhenEmpty) {
    return true;
  }

  return visibleCareerExplorerPrograms(programs, maxRecommendations).length > 0;
}
